import { settingsResource } from './resource'

export const settingsService = {
  saveCurrency: (signal) => (currency) =>
    settingsResource.post('/api/settings/currency', { currency }, { signal: signal() })
}
